import { doc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from './firebase';

export async function recordConfirmedPrintQueueBundle(bundle, userId) {
  if (!bundle?.id) throw new Error('A print bundle ID is required for audit.');
  await setDoc(
    doc(db, 'printHistory', `queue_${bundle.id}`),
    {
      userId: userId || null,
      status: 'completed',
      jobType: 'mixed_order_print_queue',
      source: 'mixed_order_print_queue',
      bundleId: bundle.id,
      orderCount: bundle.orderSnapshot ? 1 : 0,
      orderIds: bundle.orderSnapshot?.id ? [bundle.orderSnapshot.id] : [],
      sourceIds: bundle.orderKey ? [bundle.orderKey] : [],
      itemKinds: (bundle.items || []).map((item) => item?.kind).filter(Boolean),
      routes: (bundle.items || []).map((item) => ({
        kind: item?.kind || '',
        printer: item?.routing?.printer || '',
        tray: item?.routing?.printerTray || '',
        profile: item?.profileKey || '',
      })),
      createdAt: Timestamp.now(),
      outputConfirmedAt: Timestamp.now(),
    },
    { merge: true },
  );
}

export default recordConfirmedPrintQueueBundle;
